module.exports = __webpack_public_path__ + "media/images/emblems/Niederbuehren_blazono-d569674e8bc8d729127cba13ddbef78f.png";